import mixpanel, { Dict } from "mixpanel-browser";

const mixpanelID = process.env.REACT_APP_MIXPANEL_ID_NEW;
const mixpanelDebug = process.env.REACT_APP_MIXPANEL_DEBUG;
if (mixpanelID) {
  mixpanel.init(mixpanelID!, {
    debug: Boolean(mixpanelDebug),
    ignore_dnt: true,
  });
}

const actions = {
  identify: (id: string): void => {
    mixpanel.identify(id);
  },
  alias: (id: string): void => {
    mixpanel.alias(id);
  },
  track: (name: string, props?: Dict): void => {
    mixpanel.track(name, props);
  },
  people: {
    set: (props: Dict): void => {
      mixpanel.people.set(props);
    },
  },
  reset: (): void => {
    mixpanel.reset()
  },
};

const Mixpanel = actions;
export default Mixpanel;